import { countryList } from "../../utils/data";

export const getCountryName = (countryCode: string) => {
  const country = countryList.find((c) => c.code === countryCode);
  return country ? country.name : "Unknown Country";
};
